import { CampaignType } from "../../ducks/campaign/types";

const CAMPAIGN_STORAGE_KEY = "t__joyfull_campaign_mode";

/**
 * キャンペーンモード（早割 or 在庫販売）をLocalStorageで管理するクラス
 *
 * 使い方：
 * - CampaignManager.setCampaignMode('stock_item') でモードを設定
 * - CampaignManager.getCampaignMode() で現在のモードを取得
 * - CampaignManager.clearCampaignMode() でモードをクリア
 */
export class CampaignManager {
  /**
   * キャンペーンモードを設定
   * @param type - 'early_bird' または 'stock_item'
   */
  static setCampaignMode(type: CampaignType): void {
    try {
      localStorage.setItem(CAMPAIGN_STORAGE_KEY, type);
    } catch (error) {
      console.error("Failed to set campaign mode:", error);
    }
  }

  /**
   * 現在のキャンペーンモードを取得
   * @returns CampaignType | null - モードが設定されていない場合はnull
   */
  static getCampaignMode(): CampaignType | null {
    try {
      const mode = localStorage.getItem(CAMPAIGN_STORAGE_KEY);
      if (mode === "early_bird" || mode === "stock_item") {
        return mode;
      }
      return null;
    } catch (error) {
      console.error("Failed to get campaign mode:", error);
      return null;
    }
  }

  /**
   * キャンペーンモードをクリア（通常モードに戻す）
   */
  static clearCampaignMode(): void {
    try {
      localStorage.removeItem(CAMPAIGN_STORAGE_KEY);
    } catch (error) {
      console.error("Failed to clear campaign mode:", error);
    }
  }

  /**
   * 現在のモードが在庫販売かどうかをチェック
   * @returns boolean
   */
  static isStockItemMode(): boolean {
    return this.getCampaignMode() === "stock_item";
  }

  /**
   * 現在のモードが早割かどうかをチェック
   * @returns boolean
   */
  static isEarlyBirdMode(): boolean {
    return this.getCampaignMode() === "early_bird";
  }
}
